import _ from 'underscore';
import { useState, useCallback } from 'react';

export const STATES = {
  INIT: 'INIT',
  INPUT: {
    SHOW_WEBSITE: 'INPUT.SHOW_WEBSITE',
  },
  PREVIEW: {
    LOADING_ADS: 'PREVIEW.LOADING_ADS',
    SHOW_ADS: 'PREVIEW.SHOW_ADS',
  },
};

export const getIsPreviewState = state => _.values(STATES.PREVIEW).includes(state);
export const getIsInputState = state => _.values(STATES.INPUT).includes(state);
export const getIsInitState = state => state === STATES.INIT;

export function useDynamicFlowState(websiteFromUrl) {
  const initialState = websiteFromUrl ? STATES.PREVIEW.LOADING_ADS : STATES.INPUT.SHOW_WEBSITE;
  const [currentState, setCurrentState] = useState(initialState);

  const triggerTransition = useCallback(() => {
    setCurrentState((state) => {
      if (state === STATES.INIT) {
        return STATES.INPUT.SHOW_WEBSITE;
      } else if (state === STATES.INPUT.SHOW_WEBSITE) {
        return STATES.PREVIEW.LOADING_ADS;
      } else if (state === STATES.PREVIEW.LOADING_ADS) {
        return STATES.PREVIEW.SHOW_ADS;
      } else if (state === STATES.PREVIEW.SHOW_ADS) {
        return STATES.PREVIEW.LOADING_ADS;
      }
      return state;
    });
  }, []);

  return {
    currentState,
    triggerTransition,
  };
}
